import { render } from "./saved-package-row.vue?vue&type=template&id=5dd9c1b3&ts=true"
import script from "./saved-package-row.vue?vue&type=script&lang=ts"
export * from "./saved-package-row.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__